import { Component, OnInit, OnDestroy, ViewChild, ElementRef  }  from '@angular/core';
import { HTTP_PROVIDERS } from '@angular/http';
import 'rxjs/Rx';
import { ROUTER_DIRECTIVES } from '@angular/router';


import { AppConfigValues } from './shared/app-config-values';
import { AirportService } from './airports/airport.service';
import { TAFBookService } from './system-management/tafbooks/taf-book.service';
import { TAFBookB1Service } from './system-management/tafbooks/taf-book-b1/taf-book-b1.service';
import { TAFBookB2Service } from './system-management/tafbooks/taf-book-b2/taf-book-b2.service';
import { TAFBookB3Service } from './system-management/tafbooks/taf-book-b3/taf-book-b3.service';
import { TAFBookB4Service } from './system-management/tafbooks/taf-book-b4/taf-book-b4.service';
import { TAFBookB5Service } from './system-management/tafbooks/taf-book-b5/taf-book-b5.service';
import { TAFBookS1Service } from './system-management/tafbooks/taf-book-s1/taf-book-s1.service';
import { TAFBookS2Service } from './system-management/tafbooks/taf-book-s2/taf-book-s2.service';
import { TAFBookS3Service } from './system-management/tafbooks/taf-book-s3/taf-book-s3.service';
import { TAFBookGraphS1Service } from './system-management/tafbooks/taf-book-graph-s1/taf-book-graph-s1.service';
import { QueryReportService} from './query-reports/query-report.service';
import { ScenarioService, CreateScenarioRequest } from './scenario-activities/scenario.service';
import { CommonDataService } from './common-data/commondata.service';
import { AuthService } from './authentication/auth.service';
import { SystemControlService} from './shared/system-control.service';

import { UserInfoService } from './shared/user-info.service';
import { AuthGuard } from './authentication/auth-guard.service';
import { HttpHelper } from './shared/http-helper';
import { OperationsListRequest } from './airports/airport-interfaces';
import {QueryReportListRequest} from './query-reports/query-report';
import { Router, ActivatedRoute } from '@angular/router';
import { UserSession } from './shared/user-session';



@Component({
    selector: 'pm-app',
    template: `
    <div class="container-fluid" style="min-height:0px !important;" id="customApp">
            <div class='row' style=" background:url('app/images/head_app_patt.gif');" id="taf-header" 
            *ngIf="!router.url.includes('operations-graph-display')">
                <div class="col-sm-2" style="padding-left: 0;padding-right: 0;">
                    <a href="http://www.faa.gov/" class="bodyTextLink" title="FAA.gov Homepage">
                            <img src="app/images/head_app_logo.gif" alt="Federal Aviation Administration Seal" border="0" height="86">
                        </a>
                </div>
                <div class="col-sm-6" style="padding-left:0; padding-right:0;padding-bottom:0;">
                        <div class='row' style="background-size:100% auto; text-align:center;padding-bottom:0;" >
                            <label style="font-family: arial,verdana,helvetica; font-size: 18px; font-weight: bold; color: #900;" >
                                APO Terminal Area Forecast 2025
                            </label>
                        </div>
                        <div class='row' style="padding-top:0;" *ngIf="isLoggedIn">
                            <!--<nav class='nav navbar navbar-default navbar-brand' *ngIf="isLoggedIn" >
                                    <ul *ngIf="isLoggedIn" class='nav navbar-nav'>-->
                                    <div style="background:url('app/images/head_app_patt.gif');padding-left:165px;"  *ngIf="isLoggedIn">
                                        <a [routerLink]="['/welcome']"  class="btn btn-danger  btn-sm active custom-button-header">Home</a>
                                        <a [routerLink]="['/airports']" class="btn  btn-danger btn-sm active custom-button-header">Facility View</a>
                                        <a [routerLink]="['/scenario-activities']" class="btn btn-danger  btn-sm active custom-button-header" *ngIf="!isReadOnly">Scenario Activities</a>
                                        <a [routerLink]="['/query-reports']" class="btn  btn-danger  btn-sm active custom-button-header">Query Reports</a>
                                    </div>
                                       <!-- <li><a [routerLink]="['/account']" class="btn btn-danger  btn-sm active custom-button-header"> Manage Account</a></li>
                                        <li *ngIf="isAdmin"><a [routerLink]="['/system-management']" class="btn btn-danger  btn-sm active custom-button-header">System Management</a></li>
                                        <li *ngIf="isAdmin"><a [routerLink]="['/admin']" class="btn btn-danger  btn-sm active custom-button-header">Admin</a></li>-->
                            <!--        </ul>
                            </nav>-->
                        </div>
                </div>
                <div class="col-sm-3" style="background:url('app/images/head_app_patt.gif');padding-left:0; padding-right:10px; text-align:right;height:86px;">
                        <a href="http://www.faa.gov/data_research/aviation/" class="btn btn-link btn-sm ">
                            <font style="font-family: verdana,arial,helvetica; font-size: 11px; font-weight: bold; color: #0065ff;">Aviation Data and Statistics Home</font>
                        </a>
                         <button type="button" class="btn btn-link btn-xs" (click)="logout()" *ngIf="isLoggedIn">
                            <span class="glyphicon glyphicon-log-out"></span> 
                            <font style="font-family: verdana,arial,helvetica; font-size: 11px; font-weight: bold; color: #0065ff;padding-top:0; padding-bottom:0;">Log Out</font>
                        </button>
                        <form class="navbar-form no-print" (ngSubmit)="onSubmit();" *ngIf="isLoggedIn">
                            <div style="font-size: 12px; margin:2px; font-weight: bold;">
                                Go to LOCID:<input type="text" class="form-control" placeholder="Loc Id" [(ngModel)]="locId" name="locId" maxlength="4" size="4" >
                                <button type="submit" class="tn btn-default btn-xs active ">Go...</button>
                            </div>
                        </form>
                </div>
                <div class="col-sm-1"  style="padding-left: 0;padding-right: 0;">
                    <img src="app/images/head_app_right.gif" alt="" border="0" height="86px" width="100%">
                </div>
            </div>

        <div class='container' style="margin-left:20px">
            <router-outlet></router-outlet>
        </div>
        <div class='row' style="background-color:#c0e4fe;height:'29'" id="taf-footer"
        *ngIf="!router.url.includes('operations-graph-display')">
            <div class="col-sm-4" style="padding-left: 0;padding-right: 0;">
                <img src="app/images/foot_app_left.gif" alt="" border="0" height="29" width="100%">
            </div>
            <div class="col-sm-4" style="padding-left: 0;padding-right: 0;">
                <img src="app/images/foot_app_patt.gif" alt="" border="0" height="29" width="100%">
            </div>
            <div class="col-sm-4" style="padding-left: 0;padding-right: 0;">
                <img src="app/images/foot_app_right.gif" alt="" border="0" height="29" width="100%">
            </div>
        </div>
</div>`,
     styles: [require('./styles/faa_styles.css'), require('./styles/print_faa_styles.css')],
     directives: [ROUTER_DIRECTIVES],
     providers: [AppConfigValues, 
     AirportService,  
     QueryReportService,
     TAFBookService,
     TAFBookS1Service, 
     TAFBookS2Service, 
     TAFBookGraphS1Service, 
     TAFBookS3Service,
     TAFBookB1Service,
     TAFBookB2Service,
     TAFBookB3Service,
     TAFBookB4Service,
     TAFBookB5Service, 
     ScenarioService, 
     CreateScenarioRequest, 
     CommonDataService, 
     HTTP_PROVIDERS, 
     AuthService, 
     HttpHelper, 
     AuthGuard, 
     UserInfoService, 
     UserSession, 
     SystemControlService,
     OperationsListRequest,
     QueryReportListRequest]
})

export class AppComponent implements OnInit{
    pageTitle: string = 'TAF Regional Review';
    locId: string;
    isAdmin: boolean;
    isLoggedIn: boolean;
    isReadOnly: boolean;
   // private IMGFOOTRIGHT= require('/app/images/foot_app_right.gif');
    
    constructor(private route: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private _User: UserSession) {}
 

    ngOnInit(): void{
        this.isAdmin = this.authService.isInRole("System Developer");
        this.isLoggedIn = this.authService.isLoggedIn();
        this.isReadOnly = this.authService.isReadOnly();
    }

     onSubmit() { 
        this.router.navigate(['/airports', { locId: this.locId}]);
        this.locId ='';

    }

    logout(){
        this.authService.logOut();
        this.router.navigate(['/login']);
        window.location.reload();
    }
}



/** WEBPACK FOOTER **
 ** ./app/app.component.ts
 **/